import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  provideKeycloak,
  includeBearerTokenInterceptor,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
} from 'keycloak-angular';
import type { KeycloakConfig } from 'keycloak-js';

import { routes } from './app.routes';
import { accessDeniedInterceptor } from './access-denied.interceptor';
import { environment } from '../environments/environment';

const keycloakConfig: KeycloakConfig = {
  url: environment.keycloakConfig.url,
  realm: environment.keycloakConfig.realm,
  clientId: environment.keycloakConfig.clientId,
};

// Match ChargeIt-UI: only attach the bearer token to calls hitting our own API.
const apiUrlPattern = new RegExp(
  `^${environment.apiUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}(/.*)?$`,
  'i'
);

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    provideAnimationsAsync(),

    provideHttpClient(
      withInterceptors([includeBearerTokenInterceptor, accessDeniedInterceptor])
    ),
    {
      provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
      useValue: [{ urlPattern: apiUrlPattern }],
    },

    provideKeycloak({
      config: keycloakConfig,
      initOptions: {
        onLoad: 'login-required', // force redirect to Keycloak if not authenticated
        pkceMethod: 'S256',       // PKCE for SPA Authorization Code Flow
        checkLoginIframe: false,
      },
    }),
  ],
};
